function initFaqSection() {
    const faqItems = document.querySelectorAll('.faq-section__question');

    faqItems.forEach(item => {
        item.addEventListener('click', function() {
            const parent = this.parentElement;
            const answer = this.nextElementSibling;
            const isOpen = parent.classList.contains('is-active');

            // Close all other items with transition
            document.querySelectorAll('.faq-section__item').forEach(el => {
                if (el !== parent) {
                    const elAnswer = el.querySelector('.faq-section__answer');
                    el.classList.remove('is-active');
                    elAnswer.style.maxHeight = `${elAnswer.scrollHeight}px`;
                    elAnswer.offsetHeight;
                    elAnswer.style.maxHeight = '0';
                }
            });

            // Toggle current item
            if (!isOpen) {
                answer.style.maxHeight = '0';
                parent.classList.add('is-active');
                answer.offsetHeight;
                answer.style.maxHeight = `${answer.scrollHeight}px`;
            } else {
                answer.style.maxHeight = `${answer.scrollHeight}px`;
                answer.offsetHeight;
                answer.style.maxHeight = '0';
                parent.classList.remove('is-active');
            }
        });
    });
}

// Admin/Gutenberg initialization
if (window.wp && window.wp.data && window.wp.blocks) {
    wp.domReady(() => {
        initFaqSection();
        
        // Re-initialize when blocks change
        wp.data.subscribe(() => {
            const blocks = wp.data.select('core/block-editor')?.getBlocks();
            if (blocks) {
                setTimeout(initFaqSection, 100);
            }
        });
    });
} else {
    document.addEventListener('DOMContentLoaded', initFaqSection);
}

